import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "release-notes"
    }}>{`Release notes`}</h1>
    <h2 {...{
      "id": "february-10-2025"
    }}>{`February 10, 2025`}</h2>
    <h3 {...{
      "id": "android-audience-301"
    }}>{`Android Audience 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added support for the new `}<inlineCode parentName="li">{`MobileCore.initialize`}</inlineCode>{` API introduced in Core.`}</li>
    </ul>
    <h2 {...{
      "id": "may-31-2024"
    }}>{`May 31, 2024`}</h2>
    <h3 {...{
      "id": "ios-audience-501"
    }}>{`iOS Audience 5.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue in Audience hit processor and now it retries hits on recoverable URLErrors shared by Mobile Core.`}</li>
    </ul>
    <h2 {...{
      "id": "april-2-2024"
    }}>{`April 2, 2024`}</h2>
    <h3 {...{
      "id": "android-audience-300"
    }}>{`Android Audience 3.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "./index.md"
      }}>{`Adobe Audience Manager`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 3.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported Android API level to 21.`}</li>
      <li parentName="ul">{`Removed deprecated `}<inlineCode parentName="li">{`registerExtension`}</inlineCode>{` API. Use the MobileCore.registerExtensions() API for registering extensions and initializing the SDK instead.`}</li>
      <li parentName="ul">{`Added an enhancement to prevent network retries when the device's network is offline.`}</li>
    </ul>
    <h2 {...{
      "id": "march-20-2024"
    }}>{`March 20, 2024`}</h2>
    <h3 {...{
      "id": "ios-audience-500"
    }}>{`iOS Audience 5.0.0`}</h3>
    <p>{`Major version update for `}<a parentName="p" {...{
        "href": "./index.md"
      }}>{`Adobe Audience Manager`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 5.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 12.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 15.0.1 with the GitHub release.`}</li>
    </ul>
    <h2 {...{
      "id": "march-6-2024"
    }}>{`March 6, 2024`}</h2>
    <h3 {...{
      "id": "ios-audience-401"
    }}>{`iOS Audience 4.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Added max versions to Platform dependencies in podspec.`}</li>
    </ul>
    <h2 {...{
      "id": "june-7-2023"
    }}>{`June 7, 2023`}</h2>
    <h3 {...{
      "id": "ios-audience-400"
    }}>{`iOS Audience 4.0.0`}</h3>
    <p>{` Major version update for `}<a parentName="p" {...{
        "href": "./index.md"
      }}>{`Adobe Audience Manager`}</a>{` for Adobe Experience Platform Mobile SDKs on iOS compatible with Mobile Core 4.0.0. The current release includes the following changes:`}</p>
    <ul>
      <li parentName="ul">{`Updated the minimum supported version to iOS 11.0.`}</li>
      <li parentName="ul">{`Include XCFrameworks built with Xcode 14.1 with the GitHub release.`}</li>
    </ul>
    <h2 {...{
      "id": "february-3-2023"
    }}>{`February 3, 2023`}</h2>
    <h3 {...{
      "id": "android-audience-200"
    }}>{`Android Audience 2.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Major version update for `}<a parentName="li" {...{
          "href": "./index.md"
        }}>{`Adobe Audience Manager`}</a>{` for Adobe Experience Platform Mobile SDKs on Android compatible with Mobile Core 2.0.0. This library is now available as an `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-audience-android"
        }}>{`open source project on GitHub`}</a>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "may-18-2022"
    }}>{`May 18, 2022`}</h2>
    <h3 {...{
      "id": "ios-aepaudience-304"
    }}>{`iOS AEPAudience 3.0.4`}</h3>
    <ul>
      <li parentName="ul">{`Fixed an issue where lifecycle data was included in signalWithData requests.`}</li>
    </ul>
    <h2 {...{
      "id": "may-9-2022"
    }}>{`May 9, 2022`}</h2>
    <h3 {...{
      "id": "ios-aepaudience-303"
    }}>{`iOS AEPAudience 3.0.3`}</h3>
    <ul>
      <li parentName="ul">{`Fixed integration with Lifecycle extension to send lifecycle metrics when a new app session is started.`}</li>
    </ul>
    <h2 {...{
      "id": "jul-13-2021"
    }}>{`Jul 13, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepaudience-302"
    }}>{`iOS AEPAudience 3.0.2`}</h3>
    <ul>
      <li parentName="ul">{`Added support to handle the MobileCore.resetIdentities() API.`}</li>
    </ul>
    <h2 {...{
      "id": "april-1-2021"
    }}>{`April 1, 2021`}</h2>
    <h3 {...{
      "id": "ios-aepaudience-301"
    }}>{`iOS AEPAudience 3.0.1`}</h3>
    <ul>
      <li parentName="ul">{`Updated syncedVisitorIds implementation to a map`}</li>
      <li parentName="ul">{`Fixed access modifier for two classes`}</li>
    </ul>
    <h2 {...{
      "id": "january-29-2021"
    }}>{`January 29, 2021`}</h2>
    <h3 {...{
      "id": "ios-audience-300"
    }}>{`iOS Audience 3.0.0`}</h3>
    <ul>
      <li parentName="ul">{`Initial release to support `}<a parentName="li" {...{
          "href": "./index.md"
        }}>{`Adobe Audience`}</a>{` for Adobe Experience Platform Mobile SDKs for iOS in Swift. This extension library is available as an `}<a parentName="li" {...{
          "href": "https://github.com/adobe/aepsdk-audience-ios/"
        }}>{`open sourced project on GitHub`}</a>{`.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      